import * as Constants from "../constants";

class PrivateFinsembleEvent {
	private event: string;

	private source: string;

	private sourceType: string;

	private handler: Function;

	private allowDelay: boolean = false;

	private delayed: boolean = false;

	private allowCancel: boolean = false;

	private canceled: boolean = false;

	private completed: boolean = false;

	private guid: string;

	public data: any;

	public complete: Promise<void>;

	private eventComplete: Function | undefined;

	private eventCanceled: Function | undefined;

	constructor(params: {
		event: string;
		source: string;
		sourceType: string;
		data: any;
		guid: string;
		handler: Function;
	}) {
		this.event = params.event;
		this.source = params.source;
		this.sourceType = params.sourceType;
		this.data = params.data;
		this.guid = params.guid;

		if (
			Constants[this.sourceType.toUpperCase()] &&
			Constants[this.sourceType.toUpperCase()].DELAYABLE_EVENTS.includes(this.event)
		) {
			this.allowDelay = true;
		}
		if (
			Constants[this.sourceType.toUpperCase()] &&
			Constants[this.sourceType.toUpperCase()].CANCELABLE_EVENTS.includes(this.event)
		) {
			this.allowCancel = true;
		}
		this.handler = params.handler;
		this.complete = new Promise((resolve, reject) => {
			this.eventCanceled = reject;
			this.eventComplete = resolve;
		});
		this.internalHandler();
	}

	private async internalHandler(): Promise<void> {
		if (this.handler) await this.handler(this);
		if (!(this.delayed || this.canceled || this.completed)) {
			this.done();
		}
	}

	cancel(): void {
		if (this.allowCancel) {
			this.canceled = true;
			this.done();
		}
	}

	wait(): void {
		if (this.allowDelay) {
			this.delayed = true;
		} else {
			this.done();
		}
	}

	done(data?: any): void {
		this.completed = true;
		if (this.canceled) {
			if (!!this.eventCanceled) {
				this.eventCanceled();
			}
		} else {
			if (!!this.eventComplete) {
				this.eventComplete(data);
			}
		}
	}
}

export default PrivateFinsembleEvent;
